import * as React from 'react'
import { IMobilityOptionObject } from '../../types'
import { IStoreState } from '../../types/index'
import MobilityOptionsListItem from './MobilityOptionsListItem'

interface IMobilityOptionsItemProps {
  mobilityOptions: IMobilityOptionObject[]
}

class MobilityOptionsList extends React.Component<IMobilityOptionsItemProps, IStoreState> {
  constructor(props: IMobilityOptionsItemProps) {
    super(props)
  }

  public render() {
    const { mobilityOptions } = this.props
    return (
      <div>
        <div className='flex pl3 mb1'>
          <div className='col-3'>
            <p className='h5 font-grey2'>Category</p>
          </div>
          <div className='col-3'>
            <p className='h5 font-grey2'>Name</p>
          </div>
          <div className='col-3'>
            <p className='h5 font-grey2'>Able to transfer to a seat</p>
          </div>
          <div className='col-3'>&nbsp;</div>
        </div>
        {mobilityOptions &&
          Object.keys(mobilityOptions).map((item, i) => (
            <MobilityOptionsListItem key={`tmli-${i}`} mobilityOption={mobilityOptions[item]} />
          ))}
      </div>
    )
  }
}

export default MobilityOptionsList



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsList.tsx